<template>
    <f7-page v-if="!vvType" pull-to-refresh @ptr:refresh="onRefresh" :infinite-scroll="vLayout !== 'table'" @infinite="onInfiniteScroll"
             :class="listKey.toLowerCase()">

        <!-- navbar -->
        <f7-navbar :title="pageTitle + (showTotal === true && total ? ' ( ' + total + ' )' : '')" :back-link="vvType === 'vlistfield' ? '' : ' '" sliding :style="searching ? 'box-shadow: none' : ''">
            <slot v-if="sorting">

                <slot v-if="showLayout">

                    <f7-nav-right>
                        <f7-link href="#" @click="changeLayout">
                            <f7-icon :icon="'icon-layout-' + (layout === 'table' ? 'card' : 'table')"></f7-icon>
                        </f7-link>
                    </f7-nav-right>

                    <f7-nav-left>
                        <f7-link href="#" @click="showSortPopup" :class="'popover-sort-' + listKey.toLowerCase() + '-place' + (vvType === 'vlistfield' ? '-vlistfield' : '')">
                            <f7-icon icon="icon-sort"></f7-icon>
                        </f7-link>
                    </f7-nav-left>

                    <f7-nav-left v-if="showPanel">
                        <f7-link icon="icon-bars" open-panel="left"></f7-link>
                    </f7-nav-left>
                </slot>
                <slot v-else>
                    <f7-nav-right>
                        <f7-link href="#" @click="showSortPopup" :class="'popover-sort-' + listKey.toLowerCase() + '-place' + (vvType === 'vlistfield' ? '-vlistfield' : '')">
                            <f7-icon icon="icon-sort"></f7-icon>
                        </f7-link>
                    </f7-nav-right>

                    <f7-nav-left v-if="showPanel">
                        <f7-link icon="icon-bars" open-panel="left"></f7-link>
                    </f7-nav-left>
                </slot>

            </slot>
            <slot v-else>
                <f7-nav-right v-if="showPanel">
                    <f7-link icon="icon-bars" open-panel="left"></f7-link>
                </f7-nav-right>
            </slot>
        </f7-navbar>
        <!-- navbar -->

        <!-- searchbar -->
        <f7-searchbar v-if="searching"
                      cancel-link="Cancel"
                      :placeholder="searchTitle"
                      :clear-button="true"
                      @click:clear="onSearchClear"
                      @input="onSearch">
        </f7-searchbar>
        <!-- searchbar -->

        <!-- filter -->
        <f7-card v-if="filtering">

        </f7-card>
        <!-- filter -->

        <!-- statistics --
        <f7-block>
            <f7-chip :text="$root.__('Count of all') + ': ' + total" bg="deeppurple" color="white"></f7-chip>
        </f7-block>
        <!-- statistics -->

        <!-- parent -->
        <f7-card v-if="parent" class="bg-blue color-white parent">
            <f7-card-content>
                <f7-grid>
                    <f7-col v-for="field in parentFields" width="100" :tablet-width="field.description === true ? 100 : 50"
                            v-if="field.showInChildrenList !== false" :key="field.name">
                        <span class="key">{{ field.label }}:</span> {{ getFieldValue(parent, field) }}
                    </f7-col>
                </f7-grid>
            </f7-card-content>
        </f7-card>
        <!-- Parent -->

        <!-- before-list -->
        <slot name="before-list"></slot>
        <!-- before-list -->

        <!-- items -->
        <slot v-if="vLayout === 'table'">
            <!--<v-virtual-rows v-if="visibleItems && visibleItems.length > 0" style="margin-bottom:70px;"
                            :header="fields"
                            :virtual-items="visibleItems"
                            :name="listKey.toLowerCase() + (vvType ? '-' + vvType : '')"
                            :virtual-height="49"
                            :render-item-row="renderItemRow1"
                            @onItemClick="onItemClick1">
            </v-virtual-rows>-->
            <v-table
                    :items="visibleItems"
                    :columns="fields"
                    :actions="actions"
                    @onItemClick="onItemClick1">
            </v-table>
        </slot>
        <slot v-else>
            <v-virtual-cards v-if="visibleItems && visibleItems.length > 0" style="margin-bottom:70px;"
                             :render-item-header="renderItemHeader1"
                             :render-item-content="renderItemContent1"
                             :render-item-footer="renderItemFooter1"
                             :virtual-items="visibleItems"
                             :name="listKey.toLowerCase() + (vvType ? '-' + vvType : '')"
                             :virtual-height="virtualHeight || virtualHeight1" @onItemClick="onItemClick1">
            </v-virtual-cards>
        </slot>

        <!-- items -->


        <!-- after-list -->
        <slot name="after-list"></slot>
        <!-- after-list -->


        <!-- sorting -->
        <f7-popover v-if="sorting" :class="'popover-sort-' + listKey.toLowerCase() + (vvType === 'vlistfield' ? '-vlistfield' : '')">
            <f7-block-title>{{ $root.__('Sorting with:') }}</f7-block-title>
            <f7-list>
                <f7-list-item v-for="field in sortFields" link="#" @click="onSort(field.name)" :title="field.label"
                              :key="field.name">
                    <f7-icon v-if="column === field.name" :icon="'icon-' + direction.toLowerCase()"></f7-icon>
                </f7-list-item>
            </f7-list>
        </f7-popover>
        <!-- sorting -->


        <!-- floating-action-button -->
        <f7-fab v-if="addButton === true" color="orange" @click="add">
            <f7-icon icon="icon-plus"></f7-icon>
        </f7-fab>
        <!-- floating-action-button -->

    </f7-page>

    <div v-else="vvType === 'vlistfield'" class="view navbar-fixed">
        <div class="pages">
            <div class="page">
                <!-- navbar -->
                <f7-navbar :title="pageTitle + (showTotal === true && total ? ' ( ' + total + ' )' : '')" back-link="" sliding :style="searching ? 'box-shadow: none' : ''">

                    <f7-nav-right v-if="sorting">
                        <f7-link href="#" @click="showSortPopup" :class="'popover-sort-' + listKey.toLowerCase() + '-place-vlistfield'">
                            <f7-icon icon="icon-sort"></f7-icon>
                        </f7-link>
                    </f7-nav-right>

                </f7-navbar>
                <!-- navbar -->

                <!-- searchbar -->
                <f7-searchbar v-if="searching"
                              cancel-link="Cancel"
                              :placeholder="searchTitle"
                              :clear-button="true"
                              @click:clear="onSearchClear"
                              @input="onSearch">
                </f7-searchbar>
                <!-- searchbar -->

                <div class="page-content">

                    <!-- items -->
                    <v-virtual-cards v-if="visibleItems && visibleItems.length > 0" style="margin-bottom:70px;"
                                     :render-item-header="renderItemHeader1"
                                     :render-item-content="renderItemContent1"
                                     :render-item-footer="renderItemFooter1"
                                     :virtual-items="visibleItems"
                                     :name="listKey.toLowerCase() + '-' + vvType"
                                     :virtual-height="virtualHeight || virtualHeight1" @onItemClick="onItemClick1">
                    </v-virtual-cards>
                    <!-- items -->


                    <!-- sorting -->
                    <f7-popover v-if="sorting" :class="'popover-sort-' + listKey.toLowerCase() + '-vlistfield'">
                        <f7-block-title>{{ $root.__('Sorting with:') }}</f7-block-title>
                        <f7-list>
                            <f7-list-item v-for="field in sortFields" link="#" @click="onSort(field.name)" :title="field.label"
                                          :key="field.name">
                                <f7-icon v-if="column === field.name" :icon="'icon-' + direction.toLowerCase()"></f7-icon>
                            </f7-list-item>
                        </f7-list>
                    </f7-popover>
                    <!-- sorting -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Import needed components
    import VVirtualCards from '../components/VVirtualCards';
    //import VVirtualRows from '../components/VVirtualRows';
    import VTable from '../components/VTable';

    export default {
        components: {VVirtualCards, VTable},
        data: function () {
            let self = this;

            return {
                delayTimer: 0,
                visibleItems: [],
                filters: [],
                layout: self.vLayout,
            };
        },
        props: {
            vvType: String,
            listKey: String,
            singleKey: String,
            parentKey: String,
            pageTitle: String,
            params: Object,
            fields: Array,
            actions: Array,
            searching: Boolean,
            sorting: Boolean,
            filtering: Boolean,
            showPanel: Boolean,
            showLayout: Boolean,
            virtualHeight: Number,
            showTotal: Boolean,
            onItemClick: Function,
            renderItemHeader: Function,
            renderItemContent: Function,
            renderItemFooter: Function,
            parent: Object,
            addButton: Boolean,
            onAdd: Function,
            vLayout: String,
        },
        computed: {
            parentFields: function () {
                let self = this;

                if (self.parent) {
                    return self.$store.state['_' + self.parentKey.toLowerCase()].fields || [];
                }
                else
                    return [];
            },
            total: function () {
                let self = this;

                return self.$store.state['_' + self.listKey.toLowerCase()].total || '';
            },
            direction: {
                get: function () {
                    let self = this;
                    return self.params.order.direction;
                },
                set: function (val) {
                    let self = this;
                    self.params.order.direction = val;
                }
            },
            column: {
                get: function () {
                    let self = this;
                    return self.params.order.column;
                },
                set: function (val) {
                    let self = this;
                    self.params.order.column = val;
                }
            },
            q: {
                get: function () {
                    let self = this;
                    return self.params.q;
                },
                set: function (val) {
                    let self = this;
                    self.params.q = val;
                }
            },
            searchTitle: function () {
                let self = this;
                let str = [];

                if (self.searching) {
                    self.fields.forEach(function (el) {
                        if (el.search === true)
                            str.push(el.label);
                    });
                }
                str = str.join(' - ');

                return self.$root.__('Search on ( %s )', str);
            },
            searchFields: function () {
                let self = this;

                return self.fields.filter(function (el) {
                    if (el.search === true) return el;
                });
            },
            sortFields: function () {
                let self = this;

                return self.fields.filter(function (el) {
                    if (el.sort === true) return el;
                });
            },
            virtualHeight1: function () {
                let self = this;

                if (self.layout === 'table')
                    return 49;
                else if (self.contentHeight === 0)
                    return 104;
                else
                    return self.contentHeight + 136;
            },
            cellWidth: function () {
                let self = this;

                let numFields = 1;
                self.fields.forEach(function (field) {
                    if (field.showInList !== false) {
                        numFields++;
                    }
                });

                return 100 / numFields + '%';
            },
            contentHeight: function () {
                let self = this;

                if (self.layout === 'table')
                    return 49;

                let numFields = 0;
                let numDescs = 0;

                self.fields.forEach(function (field) {
                    if (field.showInList !== false) {
                        if (field.description === true)
                            numDescs ++;
                        else
                            numFields ++;
                    }
                });

                let cols = 2;
                if (self.$$(window).width() >= 768)
                    cols = 4;

                return Math.round(numFields / cols) * 25 + numDescs * 50;
            },
            /*params: function () {
                let self = this;

                let column = self.$store.state[].params.order.column;
                let direction = self.$store.state[].params.order.direction;
                let q = self.$store.state[].params.q;

                return {
                    q: q,
                    filters: {parent_id: self.parent_id},
                    order: {column: column ? column : 'chapline_categories.id', direction: direction ? direction : 'ASC'}
                };
            },*/
        },
        methods: {
            onRefresh: function () {
                //window.console.log('methods: onRefresh');
                let self = this;

                // Clear store data
                self.$store.dispatch('REFRESH', self.listKey);

                // Clear params
                self.clearParams();

                self.$store.commit('SET_FIELDS', {key: self.listKey, fields: self.fields});

                // Reload
                self.reload(false, function () {
                    self.$f7.pullToRefreshDone();
                });
            },
            onInfiniteScroll: function () {
                window.console.log('methods: onInfiniteScroll');
                let self = this;

                // Only get data if no ajax running and not loaded completely
                if (self.$store.getters.isLoadedCompletely(self.listKey) === false) {
                    if (self.$store.getters.getAjaxRunning(self.listKey.toLowerCase()) === false) {
                        self.reload(true);
                    }
                }
                else {
                    self.$$('.' + self.listKey.toLowerCase()).find('.infinite-scroll-preloader').hide();
                }
            },
            onItemClick1: function (index, object, action) {
                switch (action) {
                    case 'edit':
                        this.edit(object);
                        break;
                    case 'remove':
                        this.remove(object);
                        break;
                    default:
                        //console.log('onItemClick1 from listpage');
                        //console.log(action);
                        this.$emit('onItemClick', index, object, action);
                }
            },
            onSearchClear: function () {
                //window.console.log('methods: onSearchClear');
                let self = this;

                self.q = '';

                // Notify store
                //if (self.$store.getters.isLoadedCompletely(self.listKey) === false)
                // self.$store.commit('SETS', {key: self.listKey, params: self.params});
                self.$store.dispatch('REFRESH', self.listKey);

                self.reload();
            },
            onSearch: function (q) {
                //window.console.log('methods: onSearch');
                let self = this;

                //self.$f7.showIndicator();
                window.clearTimeout(self.delayTimer);
                self.delayTimer = window.setTimeout(function () {
                    self.q = q;

                    // Notify store
                    //if (self.$store.getters.isLoadedCompletely(self.listKey) === false)
                    // self.$store.commit('SETS', {key: self.listKey, params: self.params});
                    self.$store.dispatch('REFRESH', self.listKey);

                    self.reload();
                }, 1000);
            },
            onSort: function (col) {
                //window.console.log('methods: onSort');
                let self = this;

                if (self.column !== col)
                    self.direction = 'DESC';
                else if (self.direction === 'ASC')
                    self.direction = 'DESC';
                else
                    self.direction = 'ASC';

                // Set column
                self.column = col;

                // Notify store
                //if (self.$store.getters.isLoadedCompletely(self.listKey) === false)
                //self.$store.commit('SETS', {key: self.listKey, params: self.params});
                self.$store.dispatch('REFRESH', self.listKey);

                // Reload
                self.reload();

                // Close modal context menu
                self.$f7.closeModal('.popover-sort-' + self.listKey.toLowerCase() + (self.vvType === 'vlistfield' ? '-vlistfield' : ''));
            },
            onFilter: function () {
                //window.console.log('methods: onFilter');

                // TODO
            },
            clearParams: function () {
                // todo
                let self = this;
                self.q = '';
                self.column = self.sortFields[0].name;
                self.direction = 'ASC';
                self.filters = [];
            },
            doFilter: function (items, filter) {
                //console.log('methods: doFilter');

                // TODO

                return items;
                /*return items.filter(function (el) {
                 return el;
                 });*/
            },
            doSearch: function (items, q) {
                //window.console.log('methods: doSearch');
                let self = this;

                //if (!q)
                return items;

                /*if (self.$store.getters.isLoadedCompletely(self.listKey) === true) {
                    if (q.indexOf('id:') > -1) {
                        let id = q.substr(3, q.length - 3);
                        id = parseInt(id);
                        let found = items.find(function (el) {
                            if (el.id === id) return el;
                        });

                        if (found)
                            return [found];
                        else
                            return [];
                    }

                    return items.filter(function (obj) {
                        for (let i = 0; i < self.searchFields.length; i++) {
                            if (self.getFieldValue(obj, self.searchFields[i]).toLowerCase().indexOf(q.toLowerCase()) > -1)
                                return obj;
                        }
                    });
                }
                else
                    return items;*/
            },
            doSort: function (items, order) {
                //window.console.log('methods: doSort');
                let self = this;

                /*if (self.$store.getters.isLoadedCompletely(self.listKey) === true) {
                    let column = order.column;
                    let direction = order.direction;

                    let field = self.sortFields.find(function (el) {
                        if (el.name === column) return el;
                    });

                    if (field) {
                        let vala, valb;

                        items.sort(function compare(a, b) {
                            vala = self.getFieldValue(a, field);
                            valb = self.getFieldValue(b, field);

                            if (vala < valb)
                                return direction === 'ASC' ? -1 : 1;
                            if (vala > valb)
                                return direction === 'ASC' ? 1 : -1;

                            return 0;
                        });
                    }
                }*/
            },
            reload: function (more, callback) {
                //window.console.log('methods: reload');
                let self = this;

                let items = self.$store.getters.items(self.listKey);

                if (items === null || more === true) {
                    self.$store.dispatch('GETS', {
                        key: self.listKey, more: more, params: self.params, callback: function () {
                            self.reload();
                            if (callback)
                                callback();
                        }
                    });

                    return false;
                }

                // Filter
                //let filter = self.params.filter;
                //items = self.doFilter(items, filter);

                // Search
                //let q = self.params.q;
                //items = self.doSearch(items, q);

                // Sort
                //let order = self.params.order;
                //self.doSort(items, order);

                self.visibleItems = items;
            },
            renderItemHeader1: function (index, object) {
                let self = this;

                let callback = function () {
                    let title_fields = self.fields.filter(function (el) {
                        if (el.title === true) return el;
                    });

                    let ret = [];
                    if (title_fields.length > 0) {
                        title_fields.forEach(function (field) {
                            ret.push(self.getFieldValue(object, field));
                        });

                        return ret.join(' - ');
                    }

                    return '';
                };

                if (self.renderItemHeader)
                    return self.renderItemHeader(index, object, callback);
                else
                    return callback();
            },

            renderItemRow1: function (index, object) {
                let self = this;

                let callback = function () {
                    let ret = '';
                    let val;

                    let ta = '';
                    self.fields.forEach(function (el, i) {
                        if (el.showInList !== false || el.title === true) {
                            val = self.getFieldValue(object, el);

                            if (el.ltr === true)
                                val = '<span dir="ltr">' + val + '</span>';

                            if (el.title === true)
                                ta = 'text-align:right;';
                            else
                                ta = '';

                            ret += '<div class="vtc" style="width:' + el.width + ';' + ta + '">' + val + '</div>';
                        }
                    });

                    return ret;
                    /*self.fields.forEach(function (el) {
                        if (el.showInList !== false) {
                            val = self.getFieldValue(object, el);

                            if (el.ltr === true)
                                val = '<span dir="ltr">' + val + '</span>';

                            if (el.description === true)
                                ret += '<div class="col-100 tablet-100 description">' + val + '</div>';
                            else
                                ret += '<div class="col-50 tablet-25">' +
                                    self.$root.__(el.label) + ': ' + val + '</div>';
                        }
                    });

                    if (ret)
                        return '<div class="row fields" style="height:' + self.contentHeight + 'px;">' + ret + '</div>';
                    else
                        return '';*/
                };

                if (self.renderItemRow)
                    return self.renderItemRow(index, object, callback);
                else
                    return callback();
            },

            renderItemContent1: function (index, object) {
                let self = this;

                let callback = function () {
                    let ret = '';
                    let val;

                    self.fields.forEach(function (el) {
                        if (el.showInList !== false) {
                            val = self.getFieldValue(object, el);

                            if (val === null)
                                val = '';

                            if (el.ltr === true)
                                val = '<span dir="ltr">' + val + '</span>';

                            if (el.description === true)
                                ret += '<div class="col-100 tablet-100 description">' + val + '</div>';
                            else {
                                ret += '<div class="col-50 tablet-' + (self.vvType === "vlistfield" ? '50' : '25') + '">' +
                                    self.$root.__(el.label) + ': ' + val + '</div>';
                            }
                        }
                    });

                    if (ret)
                        return '<div class="row fields" style="height:' + self.contentHeight + 'px;">' + ret + '</div>';
                    else
                        return '';
                };

                if (self.renderItemContent)
                    return self.renderItemContent(index, object, callback);
                else
                    return callback();
            },
            renderItemFooter1: function (index, object) {
                let self = this;

                let callback = function () {
                    let ret = '';
                    self.actions.forEach(function (el) {
                        ret += '<a href="#" class="link" data-action="' + el.name + '">' +
                            (el.render ? el.render(object) : (el.label ? el.label : self.$root.__(el.name))) +
                            '</a>';
                    });

                    return ret;
                };

                if (self.renderItemFooter)
                    return self.renderItemFooter(index, object, callback);
                else
                    return callback();
            },
            getFieldValue: function(object, field) {
                let self = this;
                let fieldProp = field.prop.split('.');

                let val;
                switch (fieldProp.length) {
                    case 1:
                        val = object[fieldProp[0]];
                        break;
                    case 2:
                        val = object[fieldProp[0]][fieldProp[1]];
                        break;
                    case 3:
                        val = object[fieldProp[0]][fieldProp[1]][fieldProp[2]];
                        break;
                    case 4:
                        val = object[fieldProp[0]][fieldProp[1]][fieldProp[2]][fieldProp[3]];
                        break;
                }

                if (field.value)
                    return field.value(val, object);
                else
                    return val;
            },
            edit: function (object) {
                let self = this;

                let parentstr = '';
                if (self.parent)
                    parentstr = '&parent_id=' + self.parent.id;

                self.$f7.mainView.loadPage('/form-' + self.singleKey.toLowerCase() + '/?id=' + object.id + parentstr);
            },
            add: function () {
                let self = this;

                let parentstr = '';
                if (self.parent)
                    parentstr = '&parent_id=' + self.parent.id;

                self.$f7.mainView.loadPage('/form-' + self.singleKey.toLowerCase() + '/?id=0' + parentstr);
            },
            remove: function (object) {
                let self = this;

                self.$f7.modal({
                    text: self.$root.__('Delete, Are you sure?'),
                    buttons: [
                        {
                            text: self.$root.__('Yes'),
                            onClick: function () {
                                self.$store.dispatch('DELETE', {key: self.listKey, id: object.id, callback: function () {
                                        self.$f7.addNotification({
                                            message: self.$root.__('Successfully deleted!'),
                                            hold: 3000,
                                            button: {text: self.$root.__('Close'), color: 'blue', close: true}
                                        });

                                        if (self.parent) {
                                            self.$store.dispatch('GET', {key: self.parentKey, id: self.parent.id});
                                        }
                                    }});
                            }
                        }, {text: self.$root.__('No'), bold: true}
                    ]
                });

            },
            showSortPopup: function () {
                let self = this;
                //console.log('showSortPopup');
                //console.log(self.vvType);
                let popover = '.popover-sort-' + this.listKey.toLowerCase() + (self.vvType === 'vlistfield' ? '-vlistfield' : '');
                let place = '.popover-sort-' + this.listKey.toLowerCase() + '-place' + (self.vvType === 'vlistfield' ? '-vlistfield' : '');
                //console.log(popover);
                //console.log(place);

                this.$f7.popover(popover, place);
            },
            changeLayout: function () {
                let self = this;

                if (self.layout === 'table')
                    self.layout = 'card';
                else
                    self.layout = 'table';
            },
        },
        mounted: function () {
            //window.console.log('methods: mounted');

            let self = this;
            //console.log(self.vvType);

            window.setTimeout(function () {
                self.reload();
            }, 500);
        },
        created: function () {
            let self = this;
            //window.l = this;
            //console.log(self.virtualHeight1);
            //console.log(self.fields);
            self.$store.commit('SET_FIELDS', {key: self.listKey, fields: self.fields});

            //window.l = this;
        }
    }
</script>



// WEBPACK FOOTER //
// VListPage.vue?59f3d359